<portal-loader *ngIf="loading"></portal-loader>
<div class="detail-state portal-error" *ngIf="error">{{ error }}</div>

<div class="detail-page" *ngIf="!loading && project">

	<!-- Hero -->
	<div class="detail-hero portal-brand-fill">
		<img class="detail-hero-img" *ngIf="cover.image_url" [src]="cover.image_url" [ngStyle]="coverStyle(cover)" alt="" />
		<div class="detail-hero-overlay"></div>

		<portal-header mode="project" [projectId]="projectId" [title]="project.description || project.project_no"></portal-header>

		<div class="detail-hero-bottom d-flex align-items-end justify-content-between">
			<div class="d-flex flex-column gap-1">
				<div class="detail-project-name">
					<div class="active-badge" *ngIf="statusLabel">
						<div class="active-badge-dot"></div>
						{{ statusLabel }}
					</div>
					<span>{{ project.description || project.project_no }}</span>
				</div>
				<div class="detail-lead-time">Project {{ project.project_no }}</div>
			</div>
		</div>

		<div class="portal-logo detail-company-logo"><portal-brand-logo></portal-brand-logo></div>
	</div>

	<!-- Body: sidebar + tiles -->
	<div class="detail-body">

		<div class="detail-sidebar">
			<div class="sidebar-pm-row">
				<div class="sidebar-pm-left" *ngIf="contact?.pm_name">
					<div class="sidebar-person-name">{{ contact.pm_name }}</div>
					<div class="sidebar-person-role">{{ contact.pm_role }}</div>
				</div>
				<div class="sidebar-pm-right" *ngIf="company">
					<div class="sidebar-company-name">{{ company.company_name }}</div>
					<div class="sidebar-address">
						<span *ngFor="let line of company.address_lines; let last = last">{{ line }}<br *ngIf="!last"></span>
					</div>
					<div class="sidebar-contact d-flex flex-column gap-2">
						<div class="sidebar-contact-item d-flex align-items-center gap-2" *ngIf="company.email">
							<i class="wq wq-email"></i>
							<a [href]="'mailto:' + company.email">{{ company.email }}</a>
						</div>
						<div class="sidebar-contact-item d-flex align-items-center gap-2" *ngIf="company.phone">
							<i class="wq wq-phone"></i>
							<a [href]="'tel:' + company.phone">{{ company.phone }}</a>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="detail-tiles">
			<p class="portal-muted" *ngIf="!tiles.length" style="grid-column:1/-1">
				Nothing has been shared with you on this project yet.
			</p>
			<div class="tile" *ngFor="let t of tiles"
				[class.tile-soon]="!isBuilt(t.key)" (click)="openTile(t.key)">
				<div class="tile-alert" *ngIf="!isBuilt(t.key)"><span>Coming soon</span></div>
				<div class="tile-action" *ngIf="isBuilt(t.key) && actionText(t.key)">
					<i class="wq wq-alert"></i>{{ actionText(t.key) }}
				</div>
				<div class="tile-label">
					{{ t.label }}
					<i [class]="t.icon" class="tile-fa-icon"></i>
				</div>
			</div>
		</div>
	</div>
</div>
